import Footer from "components/Footer";
import Header from "components/Header";
import MainTitle from "components/MainTitle";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import QuickDonate from "components/QuickDonate/QuickDonate";
import QuickDonatePopUp from "components/QuickDonate/QuickDonatePopUp";
import { RootState } from "redux/rootReducer";
import { down, more, moreRotated } from "assets/icons";
import { Select, Spin } from "antd";
import ExternalProjectCard from "./ExternalProjectCard";
import { useEffect, useState } from "react";
import { getExternalProjectsCategoriesActions } from "redux/actions/ExternalProjects/getExternalProjectsCategoriesActions";
import { getExternalProjectsSubCategoriesActions } from "redux/actions/ExternalProjects/getExternalProjectsSubCategoriesActions";
import { getExternalProjectsCountriesActions } from "redux/actions/ExternalProjects/getExternalProjectsCountriesActions";
import { getExternalProjectsListActions } from "redux/actions/ExternalProjects/getExternalProjectsListActions";

const ExternalProjects = () => {
  const [categoryId, setCategoryId] = useState<number>(0);
  const [showSubCategories, setShowSubCategories] = useState(true);

  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();
  const { quickDonateStatus } = useSelector(
    (state: RootState) => state.setQuickDonatePopStateReducer
  );

  useEffect(() => {
    dispatch(getExternalProjectsCategoriesActions(1, 10));
    dispatch(getExternalProjectsCountriesActions());
    // dispatch(getExternalProjectsListActions(0, 1, 10));
  }, []);

  useEffect(() => {
    dispatch(getExternalProjectsSubCategoriesActions(categoryId, 1, 10));
  }, [categoryId]);

  ///////////////////////////////// getting the main categories
  const { getExternalProjectsLoading, externalProjectsCategoriesData } =
    useSelector(
      (state: RootState) => state.getExternalProjectsCategoriesReducer
    );

  const currentCategory = externalProjectsCategoriesData?.data?.find(
    (item: any) => {
      return item?.id === categoryId;
    }
  );

  ///////////////////////////////// getting the sub categories
  const {
    getExternalProjectsSubCategoriesLoading,
    externalProjectsSubCategoriesData,
  } = useSelector(
    (state: RootState) => state.getExternalProjectsSubCategoriesReducer
  );

  /////////////////////////////// getting the countries
  const { getExternalProjectsCountriesLoading, externalProjectsCountriesData } =
    useSelector(
      (state: RootState) => state.getExternalProjectsCountriesReducer
    );

  const countriesArabic = externalProjectsCountriesData?.data?.map(
    (item: any) => {
      return {
        label: item?.name_ar,
        value: item?.id,
      };
    }
  );
  const countriesEnglish = externalProjectsCountriesData?.data?.map(
    (item: any) => {
      return {
        label: item?.name_en,
        value: item?.id,
      };
    }
  );

  /////////////////////////// getting the projects list
  const { getExternalProjectsListLoading, externalProjectsListData } =
    useSelector((state: RootState) => state.getExternalProjectsListReducer);

  // console.log(externalProjectsSubCategoriesData);

  return (
    <>
      <Header />

      <main>
        {/* quick donate */}
        <QuickDonate />

        {/* quick donate popup  */}
        {quickDonateStatus && <QuickDonatePopUp />}

        {/* main header section  */}
        <MainTitle title={t("External Projects")} />

        <section
          className={`${
            i18n.language === "en" ? "font-Poppins" : "font-Almarai"
          } mainContainer w-full min-h-[550px]`}
        >
          <div className="px-[20px] lg:px-0 w-full h-full my-[100px] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-10 gap-y-8 lg:gap-y-0">
            {/* main categories div  **************************/}
            <div className="col-span-1 w-full bg-white rounded-[20px] shadow-shadow_main">
              {/* main title  **********/}
              <div
                className={`${
                  i18n.language === "en" ? "pl-[20px]" : "pr-[20px]"
                } w-full h-[60px] rounded-tl-[20px] rounded-tr-[20px] bg-first_color/25 flex items-center lg:text-[20px] text-second_color font-[600]`}
              >
                {t("Categories")}
              </div>

              {/* categories titles  ******/}
              <Spin spinning={getExternalProjectsLoading}>
                <div className="my-[20px] px-[15px] flex flex-col gap-8 lg:text-[18px]">
                  <p
                    onClick={() => {
                      setShowSubCategories(true);
                      dispatch(
                        getExternalProjectsSubCategoriesActions(0, 1, 10)
                      );
                    }}
                    className="flex items-center justify-between hover:text-first_color duration-150 cursor-pointer font-[500] visited:text-first_color"
                  >
                    {t("All Categories")}
                    <img
                      className={`${
                        i18n.language === "en" ? "-rotate-90" : "rotate-90"
                      }`}
                      src={down}
                      alt=""
                    />
                  </p>
                  {externalProjectsCategoriesData?.data?.map(
                    (category: any, i: number) => {
                      return (
                        <div
                          key={i}
                          onClick={() => {
                            setCategoryId(category?.id);
                            setShowSubCategories(true);
                          }}
                          className="flex items-center justify-between hover:text-first_color duration-150 cursor-pointer font-[500] visited:text-first_color"
                        >
                          {i18n.language === "en"
                            ? category?.name_en
                            : category?.name_ar}
                          <img
                            className={`${
                              i18n.language === "en"
                                ? "-rotate-90"
                                : "rotate-90"
                            }`}
                            src={down}
                            alt=""
                          />
                        </div>
                      );
                    }
                  )}
                </div>
              </Spin>
            </div>

            {/* categories detials div  ***********/}
            {showSubCategories ? (
              <div className="col-span-1 lg:col-span-2 xl:col-span-3 w-full h-full">
                <Spin spinning={getExternalProjectsSubCategoriesLoading}>
                  <div className="w-full h-[80px] text-second_color text-[20px] lg:text-[32px] font-[700px] flex items-center justify-center lg:items-start lg:justify-start">
                    {i18n.language === "en"
                      ? currentCategory?.name_en
                      : currentCategory?.name_ar}
                  </div>

                  {/* sub categories section  ****/}
                  <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-10">
                    {externalProjectsSubCategoriesData?.data?.map(
                      (subCategory: any, i: number) => {
                        return (
                          <div
                            key={i}
                            className="w-full h-[300px] flex flex-col justify-between"
                          >
                            {/* img div  */}
                            <div className="min-h-[200px] rounded-[20px] bg-red-200">
                              <img src="" alt="" />
                            </div>

                            <div className=" text-second_color text-[18px] font-[500]">
                              {i18n.language === "en"
                                ? subCategory?.name_en
                                : subCategory?.name_ar}
                            </div>

                            <p
                              onClick={() => {
                                setShowSubCategories(false);
                                dispatch(
                                  getExternalProjectsListActions(
                                    subCategory?.id,
                                    1,
                                    10
                                  )
                                );
                              }}
                              className={`flex items-center gap-3 font-${
                                i18n.language === "en" ? "Poppins" : "Almarai"
                              } font-[600] text-[18px] text-first_color cursor-pointer group`}
                            >
                              See all
                              {i18n.language === "en" ? (
                                <img
                                  className="group-hover:animate-[moveRight_1s_ease-in-out_infinite]"
                                  src={more}
                                  alt=""
                                />
                              ) : (
                                <img
                                  className="group-hover:animate-[moveLeft_1s_ease-in-out_infinite]"
                                  src={moreRotated}
                                  alt=""
                                />
                              )}
                            </p>
                          </div>
                        );
                      }
                    )}
                  </div>
                </Spin>
              </div>
            ) : (
              <div className="col-span-1 lg:col-span-2 xl:col-span-3 w-full h-full">
                {/* select country  ******/}
                <div className="p-[20px] w-full shadow-shadow_main rounded-[20px] flex flex-col gap-2">
                  <p className="text-second_color text-[20px] lg:text-[16px] font-[700px]">
                    {t("Country")}
                  </p>
                  <Spin spinning={getExternalProjectsCountriesLoading}>
                    <div className="flex flex-col md:flex-row md:items-center gap-4 lg:gap-10">
                      <Select
                        style={{
                          height: "42px",
                          width: "300px",
                          borderRadius: "30px",
                        }}
                        placeholder={t("Select Country")}
                        options={
                          i18n.language === "en"
                            ? countriesEnglish
                            : countriesArabic
                        }
                        onChange={(value: any) => {
                          dispatch(
                            getExternalProjectsListActions(value, 1, 10)
                          );
                        }}
                      />

                      <p
                        className="flex items-center justify-between hover:text-first_color duration-150 cursor-pointer font-[500] visited:text-first_color"
                        onClick={() => {
                          dispatch(getExternalProjectsListActions(0, 1, 10));
                        }}
                      >
                        {t("All Countries")}
                      </p>
                    </div>
                  </Spin>
                </div>

                <Spin spinning={getExternalProjectsListLoading}>
                  <div className="mt-[40px] grid lg:grid-cols-2 xl:grid-cols-3 gap-10">
                    {externalProjectsListData?.data?.map(
                      (project: any, i: number) => {
                        return (
                          <ExternalProjectCard key={i} project={project} />
                        );
                      }
                    )}
                  </div>
                </Spin>
              </div>
            )}
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default ExternalProjects;
